import React from 'react';

/**
 * Centre Techniques Pianos logo - inline SVG so it inherits color and scales cleanly.
 * Variant "mark" renders just the piano-keys + treble clef icon.
 * Variant "full" renders mark + wordmark.
 */
const Logo = ({ variant = 'mark', size = 36, color, className = '' }) => {
  if (variant === 'mark') {
    return (
      <svg
        viewBox="0 0 64 64"
        width={size}
        height={size}
        className={className}
        aria-label="Centre Techniques Pianos"
        role="img"
      >
        {/* Piano key bars - 5 horizontal lines in alternating greens */}
        <rect x="6" y="12" width="36" height="4" rx="1" fill="#1f6f3a" />
        <rect x="6" y="20" width="36" height="4" rx="1" fill="#7fc24b" />
        <rect x="6" y="28" width="36" height="4" rx="1" fill="#a3d96a" />
        <rect x="6" y="36" width="36" height="4" rx="1" fill="#7fc24b" />
        <rect x="6" y="44" width="36" height="4" rx="1" fill="#1f6f3a" />

        {/* Treble clef stylized */}
        <path
          d="M48 14 c4 0 6 3 6 7 c0 4 -3 7 -6 8 c0 4 1 8 1 12 c0 4 -3 7 -6 7 c-3 0 -5 -2 -5 -5 c0 -2 2 -4 4 -4 c2 0 3 1 3 3 c0 -1 -1 -2 -2 -2 c-1 0 -2 1 -2 2 c0 2 1 3 3 3 c3 0 5 -3 5 -6 c0 -3 -1 -7 -1 -10 c-3 -1 -6 -3 -6 -7 c0 -3 2 -5 4 -5 c1 0 2 0 2 1 c0 1 -1 1 -2 1 c-1 0 -2 1 -2 2 c0 2 2 3 4 3 c2 0 4 -2 4 -4 c0 -3 -2 -5 -4 -5 z"
          fill={color || 'currentColor'}
        />
      </svg>
    );
  }

  // full lockup
  return (
    <svg viewBox="0 0 320 80" width={size * 4} height={size} className={className} aria-label="Centre Techniques Pianos" role="img">
      <g transform="translate(0,8)">
        <rect x="6" y="0" width="50" height="5" rx="1" fill="#1f6f3a" />
        <rect x="6" y="11" width="50" height="5" rx="1" fill="#7fc24b" />
        <rect x="6" y="22" width="50" height="5" rx="1" fill="#a3d96a" />
        <rect x="6" y="33" width="50" height="5" rx="1" fill="#7fc24b" />
        <rect x="6" y="44" width="50" height="5" rx="1" fill="#1f6f3a" />
        <path
          d="M64 4 c5 0 8 4 8 9 c0 5 -4 9 -8 10 c0 5 2 10 2 15 c0 5 -3 9 -8 9 c-3 0 -6 -2 -6 -5 c0 -2 2 -4 4 -4 c2 0 4 1 4 3 c0 -1 -1 -2 -3 -2 c-1 0 -2 1 -2 2 c0 2 2 3 4 3 c4 0 6 -3 6 -7 c0 -4 -1 -8 -1 -12 c-4 -1 -7 -4 -7 -9 c0 -4 3 -6 5 -6 c2 0 3 1 3 2 c0 1 -1 2 -2 2 c-1 0 -3 1 -3 3 c0 2 2 4 5 4 c2 0 5 -2 5 -5 c0 -4 -3 -6 -5 -6 z"
          fill="#0f0f0f"
        />
      </g>
      <text x="86" y="34" fontFamily="'Playfair Display', serif" fontSize="22" fontWeight="700" fill="#1f6f3a" letterSpacing="0.5">
        Centre Techniques
      </text>
      <text x="146" y="58" fontFamily="'Playfair Display', serif" fontSize="20" fontWeight="700" fill="#7fc24b" letterSpacing="1">
        PIANOS
      </text>
    </svg>
  );
};

export default Logo;
